import { useMemo, type FC } from "react";
import { Link } from "react-router-dom";
import styles from "./Popular.module.css";
import ImageWithPlaceholder from "./ImageWithPlaceholder";
import { EventModel } from "../models/EventModel";

type PopularProps = {
    events: EventModel[];
    maxItems?: number;
    title?: string;
    subtitle?: string;
    onEventClick?: () => void;
};

export const Popular: FC<PopularProps> = ({
    events,
    maxItems = 3,
    title = "En vedette",
    subtitle = "",
    onEventClick
}) => {
    
    const featuredEvents = useMemo(() => events.slice(0, maxItems), [events, maxItems]);

    if (featuredEvents.length === 0) {
        return null;
    }

    return (
        <section className={styles.popular} aria-labelledby="popular-heading">
            <div className={styles.header}>
                    <h2 id="popular-heading" className={styles.title}>{title}</h2>
                <p className={styles.subtitle}>{subtitle}</p>
            </div>

            <div className={styles.list}>
                {featuredEvents.map((event) => {
                    return (
                        <Link key={event.id} to={`/details/${event.id}`} className={styles.card} onClick={onEventClick}>
                            <div className={styles.imageWrap}>
                                <ImageWithPlaceholder className={styles.image} src={event.imageUrl} alt={event.title} />
                                <div className={styles.overlay} />
                                <div className={styles.content}>
                                    <h3 className={styles.cardTitle}>{event.title}</h3>
                                    {event.locationName && <div className={styles.metaLine}>{event.locationName}</div>}
                                    {event.date && <div className={styles.metaLine}>{event.date}</div>}
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </section>
    );
};
